<ap-button [type]="'button'" ariaLabel="{{ choiceOption().text }}" (onClick)="onSelectOption()">{{ choiceOption().text }}</ap-button>
